import app from 'app';
import collection from 'pages/collection/index';
import reveal from 'layout/reveal';
import filter from 'pages/collection/filter';
import sorting from 'pages/collection/sorting';

app.add({
  collection,
  reveal,
  filter,
  sorting,
});

app.mount();
